import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Aside from "./componentes/Aside";
import Header from "./componentes/Header";
import Footer from "./componentes/Footer";
import Inicio from "./pages/Inicio";
import Login from "./pages/Login"; // ✅ Corrige el nombre
import CarguePlantilla from "./pages/rips/CarguePlantilla";
import ConsultaEnvio from "./pages/rips/ConsultaEnvio";
import DatosPrestador from "./pages/configuracion/DatosPrestador";
import Usuario from "./pages/configuracion/Usuarios";
import Reportes from "./pages/reportes/Reportes";

function App() {
  return (
    <Router>
      <Routes>
        {/* Página de Login (sin layout) */}
        <Route path="/" element={<Login />} />

        {/* Rutas con layout */}
        <Route
          path="/*"
          element={
            <div className="wrapper">
              <Header />
              <Aside />
              <div className="content-wrapper">
                <section className="content pt-3">
                  <div className="container-fluid">
                    <Routes>
                      <Route path="inicio" element={<Inicio />} />
                      <Route path="cargue_plantilla" element={<CarguePlantilla />} />
                      <Route path="consulta_envio" element={<ConsultaEnvio />} />
                      <Route path="datos_prestador" element={<DatosPrestador />} />
                      <Route path="gestion_usuarios" element={<Usuario />} />
                      <Route path="reportes" element={<Reportes />} />
                      {/* Aquí puedes ir agregando más rutas internas */}
                    </Routes>
                  </div>
                </section>
              </div>
              <Footer />
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
